import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { EsgDeleteIcon } from 'assets';
import { DeleteDialog } from 'components';
import { useDeleteScorecardRow } from 'hooks';

interface DeleteRowButtonProps {
    rowId: number;
    onDelete?: (rowId: number) => void;
    disabled?: boolean;
}

export const DeleteRowButton: React.FC<DeleteRowButtonProps> = ({ rowId, onDelete, disabled = false }) => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const { mutateAsync: deleteRow, isLoading: isDeleting } = useDeleteScorecardRow();

    const handleOpenDeleteDialog = () => {
        setDeleteDialogOpen(true);
    };

    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
    };

    const handleConfirmDelete = async () => {
        try {
            await deleteRow(rowId);
            if (onDelete) {
                onDelete(rowId);
            }
            handleCloseDeleteDialog();
        } catch (error) {
            // Error handling is done in the mutation hook
        }
    };

    return (
        <>
            <Tooltip
                arrow
                placement="top"
                title="Delete row">
                <IconButton
                    size="small"
                    onClick={handleOpenDeleteDialog}
                    disabled={disabled}
                    sx={{
                        opacity: disabled ? 0.5 : 1,
                        cursor: disabled ? 'not-allowed' : 'pointer'
                    }}
                >
                    <EsgDeleteIcon color="#EF2E14" style={{ width: "16px", height: "16px" }} />
                </IconButton>
            </Tooltip>
            {deleteDialogOpen && (
                <DeleteDialog
                    isOpen={deleteDialogOpen}
                    onCancel={handleCloseDeleteDialog}
                    onDeleteClick={handleConfirmDelete}
                    target="Scorecard row"
                    title="Delete row?"
                    confirmButtonDisabled={isDeleting}
                    confirmTitle={isDeleting ? "Deleting..." : "Delete"}
                />
            )}
        </>
    );
};
